"use client"
import { FlexCenter, Media, Separator, SpaceBetween } from "@opensea/ui-kit"
import { useChainArch } from "@opensea/wallet"
import { useHideNavigationLayoutComponents } from "@/components/navigation/use-hide-navigation-layout-components"
import { useSubscriptionStatus } from "@/hooks/use-subscription/use-subscription-status"
import { AggregatorHoverable } from "./AggregatorHoverable"
import { NetworksHoverable } from "./NetworksHoverable"
import { PageFooterContainer } from "./PageFooterContainer"
import { PageFooterCurrencyToggle } from "./PageFooterCurrencyToggle"
import { PageFooterGwei } from "./PageFooterGwei"
import { PageFooterNativeCurrencyPrice } from "./PageFooterNativeCurrencyPrice"
import { PageFooterPersonaToggle } from "./PageFooterPersonaToggle"
import { PageFooterPrivacyPolicy } from "./PageFooterPrivacyPolicy"
import { PageFooterSocialLinks } from "./PageFooterSocialLinks"
import { PageFooterSupportLink } from "./PageFooterSupportLink"
import { PageFooterTermsOfService } from "./PageFooterTermsOfService"
import { PageFooterThemeToggle } from "./PageFooterThemeToggle"
import { PageFooterVolumeToggle } from "./PageFooterVolumeToggle"
import { SubscriptionLiveIndicator } from "./SubscriptionLiveIndicator"

const SEPARATOR = <Separator className="mx-4 h-4" orientation="vertical" />

export function PageFooter() {
  const result = useSubscriptionStatus()
  const hideNavigationLayoutComponents = useHideNavigationLayoutComponents()
  const chainArch = useChainArch()

  if (hideNavigationLayoutComponents) {
    return null
  }

  return (
    <PageFooterContainer>
      <SpaceBetween className="w-full">
        <FlexCenter>
          <SubscriptionLiveIndicator />
          {Boolean(result) && SEPARATOR}
          <Media greaterThanOrEqual="xl">
            <AggregatorHoverable />
            {SEPARATOR}
            <NetworksHoverable />
            {SEPARATOR}
          </Media>
          <PageFooterTermsOfService />
          {SEPARATOR}
          <PageFooterPrivacyPolicy />
          <Media greaterThanOrEqual="2xl">
            {SEPARATOR}
            <PageFooterSocialLinks />
          </Media>
        </FlexCenter>
        <FlexCenter>
          <PageFooterNativeCurrencyPrice />
          {chainArch === "EVM" && (
            <>
              {SEPARATOR}
              <PageFooterGwei />
            </>
          )}
          {SEPARATOR}
          <PageFooterSupportLink />
          {SEPARATOR}
          <FlexCenter className="gap-2">
            <PageFooterThemeToggle />
            <PageFooterPersonaToggle />
            <PageFooterCurrencyToggle />
            <PageFooterVolumeToggle />
          </FlexCenter>
        </FlexCenter>
      </SpaceBetween>
    </PageFooterContainer>
  )
}
